export enum FilterSource {
  // Resolved server-side via SearchUrlAnalysisService (e.g. /gucci/ -> brand.id:2).
  UrlAnalysis = 'url_analysis',
  // Derived from the URL pathname (campaign id, catalogLinksWithoutLanguage,
  // /express-delivery/ -> stock, /direct-shipping/ -> directShippingEligible,
  // path-driven universe.id from applicableSizeIds / kids catalog).
  UrlPath = 'url_path',
  // Parsed from the URL hash fragment (#brand=2_priceMin=100).
  UrlHash = 'url_hash',
  // Toggled by the user via a filter chip / control.
  User = 'user',
  // Auto-applied from the user's saved size preferences.
  MySizes = 'my_sizes',
  // Auto-applied via the marketing filters API (free shipping, local-to-local).
  MarketingFilter = 'marketing',
  // Loaded from a recent search (URL contains searchDate query param).
  RecentSearch = 'recent_search',
}
